<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item label="标题">
        <el-input v-model="filters.Title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.Status" clearable placeholder="请选择状态">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column prop="Id" label="ID" width="60"></el-table-column>
      <el-table-column label="封面" width="120">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.CoverUrl"
            :src="scope.row.CoverUrl"
            :preview-src-list="[scope.row.CoverUrl]"
            style="width: 100px; height: 56px"
            fit="cover"
          ></el-image>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="Title" label="标题" width="200"></el-table-column>
      <el-table-column label="视频" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <a v-if="scope.row.VideoUrl" :href="scope.row.VideoUrl" target="_blank" style="color: #409EFF">
            {{ scope.row.VideoUrl }}
          </a>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="时长" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.Duration">{{ formatDuration(scope.row.Duration) }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="Sort" label="排序" width="70"></el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status === 1 ? 'success' : 'info'" size="small">
            {{ scope.row.Status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!--新增/编辑弹窗-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">
        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.Title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="封面图" prop="CoverUrl">
          <el-upload
            class="cover-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleCoverUploadSuccess"
            :before-upload="beforeImageUpload"
          >
            <img v-if="editForm.CoverUrl" :src="editForm.CoverUrl" class="cover-image" />
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸: 16:9，支持jpg/png格式</div>
        </el-form-item>

        <el-form-item label="视频文件" prop="VideoUrl">
          <el-upload
            class="video-uploader"
            action=""
            :show-file-list="false"
            :http-request="handleVideoPut"
            :before-upload="beforeVideoUpload"
            accept=".mp4"
          >
            <el-button size="small" type="primary" :loading="videoUploading">
              {{ videoUploading ? '上传中...' : '点击上传视频' }}
            </el-button>
            <div slot="tip" class="el-upload__tip">支持mp4格式，建议大小不超过500MB</div>
          </el-upload>
          <div v-if="editForm.VideoUrl" style="margin-top: 10px">
            <video :src="editForm.VideoUrl" controls style="max-width: 100%; max-height: 200px"></video>
          </div>
          <el-progress
            v-if="videoUploadProgress > 0 && videoUploadProgress < 100"
            :percentage="videoUploadProgress"
          ></el-progress>
        </el-form-item>

        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="3"
            v-model="editForm.Description"
            placeholder="请输入描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input-number v-model="editForm.Sort" :min="0" :max="9999"></el-input-number>
          <span style="margin-left: 10px; color: #999">数字越小越靠前</span>
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="editForm.Status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  PlatformGuideGetList,
  PlatformGuideAdd,
  PlatformGuideUpdate,
  PlatformGuideDelete
} from '../../api/api'
const OSS = require('ali-oss')

export default {
  name: 'PlatformGuide_list',
  data() {
    return {
      filters: {
        Title: '',
        Status: -1
      },
      tableData: [],
      listLoading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,

      dialogVisible: false,
      dialogTitle: '',
      saveLoading: false,
      videoUploading: false,
      videoUploadProgress: 0,

      editForm: {
        Id: 0,
        Title: '',
        VideoUrl: '',
        CoverUrl: '',
        Duration: null,
        Description: '',
        Sort: 0,
        Status: 1
      },

      editFormRules: {
        Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        VideoUrl: [{ required: true, message: '请上传视频', trigger: 'change' }]
      },

      uploadUrl: '/images/Upload/Pic',
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('Token')
      },
      ossClient: null
    }
  },
  mounted() {
    this.initOssClient()
    this.loadData()
  },
  methods: {
    async loadData() {
      this.listLoading = true
      try {
        const { data } = await PlatformGuideGetList({
          page: this.pageIndex,
          pageSize: this.pageSize,
          title: this.filters.Title,
          status: this.filters.Status
        })

        if (data.success) {
          this.tableData = data.response.data
          this.total = data.response.dataCount
        } else {
          this.$message.error(data.msg || '加载失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('加载失败')
      } finally {
        this.listLoading = false
      }
    },

    handleSearch() {
      this.pageIndex = 1
      this.loadData()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },

    handleCurrentChange(val) {
      this.pageIndex = val
      this.loadData()
    },

    handleAdd() {
      this.dialogTitle = '新增平台指引'
      this.editForm = {
        Id: 0,
        Title: '',
        VideoUrl: '',
        CoverUrl: '',
        Duration: null,
        Description: '',
        Sort: 0,
        Status: 1
      }
      this.videoUploadProgress = 0
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },

    handleEdit(row) {
      this.dialogTitle = '编辑平台指引'
      this.editForm = { ...row }
      this.videoUploadProgress = 0
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },

    handleSave() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return

        this.saveLoading = true
        try {
          const apiFunc = this.editForm.Id > 0 ? PlatformGuideUpdate : PlatformGuideAdd
          const { data } = await apiFunc(this.editForm)

          if (data.success) {
            this.$message.success(data.msg || '保存成功')
            this.dialogVisible = false
            this.loadData()
          } else {
            this.$message.error(data.msg || '保存失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('保存失败')
        } finally {
          this.saveLoading = false
        }
      })
    },

    handleDelete(row) {
      this.$confirm('确定要删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await PlatformGuideDelete({ id: row.Id })

          if (data.success) {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(data.msg || '删除失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },

    initOssClient() {
      this.ossClient = new OSS({
        region: 'oss-cn-shanghai',
        accessKeyId: 'LTAI5t7FwVELwhxrxav6LkbZ',
        accessKeySecret: '74Y3NDZmJqiIHQAm03dXfMRSnUG2fd',
        bucket: 'share-ui',
      })
    },

    handleCoverUploadSuccess(res) {
      if (res.success) {
        const ossBaseUrl = 'https://share.51i.cc/'
        this.editForm.CoverUrl = ossBaseUrl + res.response
        this.$message.success('封面上传成功')
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },

    async handleVideoPut(param) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '视频上传中......',
        })
        const file = param.file
        let filename = this.getFilename()
        const index = file.name.lastIndexOf('.')
        const ext = file.name.substr(index)
        filename = filename + ext

        await this.ossClient.multipartUpload('202303_PlusStudy/Upload/' + filename, file)
          .then((res) => {
            this.editForm.VideoUrl = 'https://share.51i.cc/' + res.name
            this.$message.success('视频上传成功！')
            this.videoUploading = false
            this.videoUploadProgress = 0
            loading.close()
          })
          .catch((err) => {
            param.onError(err)
            console.error('上传失败:', err)
            this.$message.error('视频上传失败！')
            this.videoUploading = false
            this.videoUploadProgress = 0
            loading.close()
          })
      } catch (e) {
        console.error(e)
        param.onError(e)
        this.$message.error('视频上传失败！')
        this.videoUploading = false
        this.videoUploadProgress = 0
      }
    },

    getFilename() {
      const date = new Date()
      let fmt = 'yyyyMMddHHmmssS'
      const o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds(),
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
        }
      }
      return fmt
    },

    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },

    beforeVideoUpload(file) {
      const isVideo = file.type.startsWith('video/')
      const isLt500M = file.size / 1024 / 1024 < 500

      if (!isVideo) {
        this.$message.error('只能上传视频文件!')
        return false
      }
      if (!isLt500M) {
        this.$message.error('视频大小不能超过 500MB!')
        return false
      }

      this.videoUploading = true
      this.videoUploadProgress = 0
      return true
    },

    formatDuration(seconds) {
      if (!seconds) return '-'
      const minutes = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${minutes}:${secs.toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped>
.cover-uploader,
.video-uploader {
  display: inline-block;
}

.cover-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cover-uploader .el-upload:hover {
  border-color: #409EFF;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.cover-image {
  width: 178px;
  height: 100px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}
</style>
